<button mat-menu-item mat-dialog-close (click)="newBuilding()" i18n>NEW BUILDING</button>
<button mat-menu-item [matMenuTriggerFor]="vertex">
  <span i18n>NEW VERTEX</span>
  <mat-icon class="app-feature-menu-icon">arrow_right</mat-icon>
</button>

<mat-menu #vertex="matMenu">
  <button mat-menu-item mat-dialog-close (click)="newVertex('CO')" i18n>CO - CENTRAL OFFICE</button>
  <button mat-menu-item mat-dialog-close (click)="newVertex('PL')" i18n>PL - POLE</button>
  <button mat-menu-item mat-dialog-close (click)="newVertex('AC')" i18n>AC - AERIAL CONNECTION</button>
  <button mat-menu-item mat-dialog-close (click)="newVertex('UB')" i18n>UB - MANHOLE</button>
</mat-menu>
